import { useRevalidator, useRouteError } from 'react-router-dom'
import { ApiError } from '../lib/api'
import { Button, Panel, PanelBody, PanelHeading, PanelTitle } from './common'

const NOT_FOUND_STATUSES: readonly number[] = [403, 404]

export function RouteErrorPanel() {
  const error = useRouteError()
  const { revalidate } = useRevalidator()

  if (error instanceof ApiError && NOT_FOUND_STATUSES.includes(error.status)) {
    return (
      <Panel data-testid="route-not-found">
        <PanelHeading>
          <PanelTitle>Página no encontrada</PanelTitle>
        </PanelHeading>
        <PanelBody>Lo que buscas no existe o no tienes acceso a ello.</PanelBody>
      </Panel>
    )
  }
  return (
    <Panel data-testid="route-error">
      <PanelHeading>
        <PanelTitle>No pudimos cargar esta pantalla</PanelTitle>
      </PanelHeading>
      <PanelBody>
        <p>Revisa tu conexión e inténtalo nuevamente.</p>
        <Button onClick={revalidate}>Reintentar</Button>
      </PanelBody>
    </Panel>
  )
}
